// defs
import { NotificationTypeEnum } from '@/stores/notification/defs';
import useNotificationsStore from '@/stores/notification';
const getNotificationId = () => Date.now();
const useNotification = () => {
    const { addNotification, removeNotification } = useNotificationsStore((store) => ({
        addNotification: store.addNotification,
        removeNotification: store.removeNotification,
    }));
    const notify = ({ message, type = NotificationTypeEnum.SUCCESS, duration = -1, }) => {
        if (!message) {
            return;
        }
        const notificationId = getNotificationId();
        addNotification({
            id: notificationId,
            message,
            type,
            duration,
        });
        if (duration > 0) {
            window.setTimeout(() => {
                removeNotification(notificationId);
            }, duration);
        }
        return notificationId;
    };
    return {
        notify,
    };
};
export default useNotification;
